module.exports = __webpack_public_path__ + "img/RedditDark.b587bfde.svg";